// @flow
import * as React from "react"
import { compose, withHandlers, type HOC } from "recompose"
import withUser from "hoc/withUser"
import withConnect from "hoc/withConnect"
import Button from "components/Button"
import ProductAvailability from "modals/ProductAvailability"
import { selectSearchParams } from "data/search/selectors"
import { openModal } from "data/modals/actions"
import urls from "data/router/urls"
import withRouter from "hoc/withRouter"
import type {
    ProductVariant,
    ProductVariantAvailableAffiliate,
} from "data/product/types"

const Reserve = ({ handleReserve, handlePickDates, datesSelected }) => (
  <Button fullwidth onClick={handlePickDates}>
    Try It
  </Button>
)

const mapStateToProps = state => ({
  searchParams: selectSearchParams(state),
})

const mapDispatchToProps = {
  openModal,
}

type Outter = {|
  productVariant: ProductVariant,
  variantAffiliate: ProductVariantAvailableAffiliate,
|}

const enhancer: HOC<*, Outter> = compose(
  withUser(),
  withRouter,
  withConnect(mapStateToProps, mapDispatchToProps),
  withHandlers({
    handlePickDates: props => () => props.openModal(ProductAvailability, {
      productVariant: props.productVariant,
      variantAffiliate: props.variantAffiliate,
      callback: () => {
        props.history.push(
          urls.cart(
            props.productVariant.id,
            props.variantAffiliate.affiliateId,
          ),
        )
      }
    })
  }),
)

export default enhancer(Reserve)



// WEBPACK FOOTER //
// ./src/pages/Product/Detail/Reserve/index.js